module.exports = {template: '<svg width="28" height="28" viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><circle fill="#AAA" cx="14" cy="14" r="14"/><path d="M15.12 11.874h2.343l-.285 2.563H15.12v7.438h-3.07v-7.438H10.5v-2.563h1.55v-1.55c0-1.098.254-1.931.76-2.501.528-.549 1.382-.823 2.564-.823h2.057v2.564h-1.266c-.295 0-.485.02-.57.063-.147.021-.253.084-.316.19-.042.084-.084.19-.127.316 0 .021-.005.085-.015.19-.011.106-.016.19-.016.253v1.298z" fill="#FFF"/></g></svg>'};


//////////////////
// WEBPACK FOOTER
// ./static/svg/raw/icon_contact_fb_grey.svg
// module id = 1824
// module chunks = 4